import { TextEntryFilterOption } from '../types';
import { CSVTextEntry } from '../../components';

export const config: TextEntryFilterOption = {
  id: 'omicsExplorer.filters.cosmicIds',
  title: {
    id: 'omicsExplorer.filters.cosmicIds',
    defaultMessage: 'COSMIC IDs',
  },
  content: CSVTextEntry,
  injectedProps: {
    searchKey: 'cosmicId',
    textEntryOption: {
      id: 'omicsExplorer.filters.cosmicIds',
      searchValue: '',
      placeholderIntlLabel: {
        id: 'omicsExplorer.filters.cosmicIds.placeholderLabel',
        defaultMessage: 'Add (comma-separated)',
      },
    },
  },
};
